import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { mget, mpost, errMsg } from "@/manager/lib";
import { Card, Field, goldBtn } from "@/manager/ui";

const TYPE = { consumo: "Consumo", perdida: "Pérdida", entrada: "Entrada", ajuste: "Ajuste", recepcion: "Recepción" };

export default function ConsumptionTab({ ev, reload }) {
  const [products, setProducts] = useState([]);
  const [f, setF] = useState({ product_id: "", type: "consumo", quantity: "" });
  useEffect(() => { mget("/inventory").then((d) => setProducts(d.products)); }, [ev.movements.length]);

  const submit = async () => {
    if (!f.product_id || !f.quantity) return toast.error("Elige producto y cantidad");
    try {
      const p = await mpost("/inventory/movements", { ...f, quantity: Number(f.quantity), event_id: ev.id });
      toast.success(`${p.name}: quedan ${p.quantity} ${p.unit}`);
      if (p.state === "bajo_minimo") toast.warning(`¡${p.name} bajo mínimo! Hay que llamar al proveedor.`);
      setF({ ...f, quantity: "" }); reload();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="space-y-5">
      <Card className="p-5">
        <h3 className="font-display text-lg mb-1">Registrar consumo real</h3>
        <p className="text-xs text-[#6b6a66] mb-4">Los consumos previstos no descuentan stock; solo lo que registres aquí.</p>
        <div className="flex flex-wrap gap-3 items-end">
          <Field label="Producto" className="w-64">
            <Select value={f.product_id} onValueChange={(v) => setF({ ...f, product_id: v })}>
              <SelectTrigger data-testid="cons-product"><SelectValue placeholder="Elegir…" /></SelectTrigger>
              <SelectContent>{products.map((p) => <SelectItem key={p.id} value={p.id}>{p.name} ({p.quantity} {p.unit})</SelectItem>)}</SelectContent>
            </Select>
          </Field>
          <Field label="Tipo" className="w-36">
            <Select value={f.type} onValueChange={(v) => setF({ ...f, type: v })}>
              <SelectTrigger data-testid="cons-type"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="consumo">Consumo</SelectItem><SelectItem value="perdida">Pérdida</SelectItem></SelectContent>
            </Select>
          </Field>
          <Field label="Cantidad" className="w-28"><Input type="number" min="0" step="any" value={f.quantity} onChange={(e) => setF({ ...f, quantity: e.target.value })} data-testid="cons-qty" /></Field>
          <Button className={goldBtn} onClick={submit} data-testid="cons-submit">Registrar</Button>
        </div>
      </Card>
      <Card className="p-5">
        <h3 className="font-display text-lg mb-3">Movimientos de este evento</h3>
        {ev.movements.map((m) => (
          <p key={m.id} className="text-sm flex justify-between py-1.5 border-b border-[#f0ece4] last:border-0" data-testid={`cons-move-${m.id}`}>
            <span>{TYPE[m.type]} · {m.product_name}</span>
            <span className={m.quantity < 0 ? "text-rose-700" : "text-emerald-700"}>{m.quantity > 0 ? "+" : ""}{m.quantity} → {m.after}</span>
          </p>
        ))}
        {!ev.movements.length && <p className="text-sm text-[#6b6a66]">Sin movimientos todavía.</p>}
      </Card>
    </div>
  );
}
